module.exports = self["Vuex"];